import Vue from 'vue';

export const RendererEventBus = new Vue();

export const RendererEvents = {
    RESIZE: 'resize',
};
